import React from 'react';
import { FileText, Download, Edit2, Trash2 } from 'lucide-react';
import { FUEL_META } from './constants';  // Changé
import { fmt, fmtUSD } from './formatters';  // Changé

const TransactionsTable = ({ transactions, generatingInvoice, onViewInvoice, onDownloadInvoice, onEdit, onDelete }) => {
  if (transactions.length === 0) {
    return <p className="text-center text-gray-500 py-16">No transactions found.</p>;
  }

  return (
    <div className="bg-gray-800/50 rounded-xl border border-gray-700 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-800 border-b border-gray-700">
            <tr>
              {['#', 'Date / Time', 'Aircraft', 'Owner', 'Type', 'Gallons', 'Price/gal', 'Total', 'Staff', 'Invoice', ''].map(h => (
                <th key={h} className="p-3 text-left text-gray-400 text-xs whitespace-nowrap">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {transactions.map(tx => {
              const meta = FUEL_META[tx.fuel_type] || FUEL_META['JetA'];
              return (
                <tr key={tx.id} className="border-b border-gray-700/50 hover:bg-gray-700/20 transition">
                  <td className="p-3 text-blue-400 text-xs font-mono whitespace-nowrap">
                    {tx.transaction_number || '—'}
                  </td>
                  <td className="p-3 text-gray-300 text-xs whitespace-nowrap">
                    {tx.timestamp ? new Date(tx.timestamp).toLocaleString('en-US') : '—'}
                  </td>
                  <td className="p-3 text-white text-sm font-medium">{tx.tail_number || '—'}</td>
                  <td className="p-3 text-gray-300 text-xs">{tx.owner_name || '—'}</td>
                  <td className="p-3">
                    <span className={`px-2 py-1 rounded text-xs ${meta.badge}`}>{meta.label}</span>
                  </td>
                  <td className="p-3 text-gray-300 text-sm">{fmt(tx.gallons, 2)}</td>
                  <td className="p-3 text-gray-300 text-sm">{fmtUSD(tx.price_per_gallon)}</td>
                  <td className="p-3 text-green-400 text-sm font-medium">{fmtUSD(tx.total_amount)}</td>
                  <td className="p-3 text-gray-500 text-xs">{tx.staff_name || 'Self-service'}</td>
                  <td className="p-3">
                    <div className="flex items-center gap-2">
                      <button onClick={() => onViewInvoice(tx)}
                        disabled={generatingInvoice === tx.id}
                        className="text-green-400 hover:text-green-300 transition disabled:opacity-40" title="View Invoice">
                        {generatingInvoice === tx.id
                          ? <div className="w-3 h-3 border border-green-400 border-t-transparent rounded-full animate-spin" />
                          : <FileText size={14} />}
                      </button>
                      <button onClick={() => onDownloadInvoice(tx)}
                        disabled={generatingInvoice === tx.id}
                        className="text-yellow-400 hover:text-yellow-300 transition disabled:opacity-40" title="Download Invoice">
                        <Download size={14} />
                      </button>
                      <button onClick={() => onEdit(tx)}
                        className="text-blue-400 hover:text-blue-300 transition" title="Edit">
                        <Edit2 size={14} />
                      </button>
                      <button onClick={() => onDelete(tx)}
                        className="text-red-400 hover:text-red-300 transition" title="Delete">
                        <Trash2 size={14} />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TransactionsTable;